import React from 'react'
import PropTypes from 'prop-types'
import { GGButton } from '../../../shared/new_components/GGButton'

const HelpItem = ({ item, position }) => {
  const openInNewTab = (url) => window.open(url, '_blank', 'noopener,noreferrer')
  return (
    <div className='help-item'>
      <div className='display-flex'>
        <div className='square'>
          <i className={`fa-regular fa-${item['icon']}`} aria-hidden='true'></i>
        </div>
        <div>
          <h4 className='text-ds-h6'>{position + 1}. {item['name']}</h4>
        </div>
      </div>
      <div className='display-flex'>
        {item['watch_link'] &&
          <GGButton variant='ghost' label={window.I18n.t('gg_golf_hub.dashboard.watch')} onClick={() => openInNewTab(item['watch_link'])} />
        }
        <GGButton variant='ghost' label={window.I18n.t('gg_golf_hub.dashboard.read')} onClick={() => openInNewTab(item['read_link'])} />
      </div>
    </div>
  )
}

HelpItem.propTypes = {
  item: PropTypes.object,
  position: PropTypes.number,
}

export default HelpItem
